import { render, staticRenderFns } from "./DisabledTooltip.vue?vue&type=template&id=45decf90"
import script from "./DisabledTooltip.vue?vue&type=script&lang=js"
export * from "./DisabledTooltip.vue?vue&type=script&lang=js"
import style0 from "./DisabledTooltip.vue?vue&type=style&index=0&id=45decf90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports